import escapeHtml from 'escape-html';
import {Descendant, Text} from 'slate';

export const jsonSlateToHtml = (nodes: Descendant[]): string => {
  return nodes.map((node: Descendant) => serialize(node)).join('');
};

const serialize = (node: Descendant): string => {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text);

    let style = '';
    if (node.bold) {
      style += 'font-weight: bold;';
    }
    if (node.italic) {
      style += 'font-style: italic;';
    }
    if (node.underline) {
      style += 'text-decoration: underline;';
    }
    if (node.fontSize) {
      style += `font-size: ${node.fontSize};`;
    }

    if (node.color) {
      style += `color: ${node.color};`;
    }
    if (node.background) {
      style += `background-color: ${node.background};`;
    }

    if (style !== '') {
      string = `<span style="${style}">${string}</span>`;
    } else {
      string = `<span>${string}</span>`;
    }

    return string;
  }

  const children = node.children
    .map((node: Descendant) => serialize(node))
    .join('');

  switch (node.type) {
    case 'text-align':
      return `<p style="text-align: ${node.align}">${children}</p>`;
    case 'link':
      return `<a href="${node.url}">${children}</a>`;
    default:
      return `<p>${children}</p>`;
  }
};
